import { Injectable } from "@angular/core";
import { PoLookupColumn } from "@po-ui/ng-components";

@Injectable({
  providedIn: 'root'
})
export class PgcLookupHelper {

  //-- Converte colunas do tipo PoLookupColumn em uma string para realizar filtro de um valor
  convertColumnsToQueryString(columns: Array<PoLookupColumn> | any, value: any): string {
    let filter: string = ''

    value = typeof value === 'object' ? value.filter : value;

    if (value) {
      value = value?.toLowerCase()
      columns.forEach((element, index) => {
        filter += index === 0 ? '(' : ''
        
        //Verifica se o campo possui o tipo "string" 
        if(element.type === 'string'){
          filter += `contains(toupper(${element.property}),'${value.toUpperCase()}')`;
          
          if (index + 1 != columns.length) {
            filter += ' or ';
          }
        
          filter += index + 1 === columns.length ? ')' : ''
        }
      });
    }

    return filter;
  }
}
